import { useTranslation } from "react-i18next";
import { MENU_CONTENT_TYPES } from "../../../../../constants/menuContentType";

const Step2ChoosePath = ({ setWizardPath, setDraft, setActiveStep, goPrev }) => {
  const { t } = useTranslation();

  const chooseInteractive = () => {
    setWizardPath("interactive");
    setDraft((prev) => ({
      ...prev,
      wizardPath: "interactive",
      menu: {
        ...prev.menu,
        menuContentType: MENU_CONTENT_TYPES.INTERACTIVE,
      },
    }));
    setActiveStep(2);
  };

  const chooseStatic = () => {
    setWizardPath("static");
    setDraft((prev) => ({
      ...prev,
      wizardPath: "static",
      menu: {
        ...prev.menu,
        menuContentType: MENU_CONTENT_TYPES.STATIC,
      },
    }));
    setActiveStep(2);
  };

  return (
    <>
      <div className="mt-3 start-step-content">
        <div className="start-step-hero">
          <h2 className="start-step-title">
            <span className="step-badge">2</span>
            {t("wizardChoosePathHeading")}
          </h2>
          <p className="start-step-subtitle">{t("wizardChoosePathSub")}</p>
        </div>

        <div className="start-step2" role="radiogroup" aria-label={t("wizardChoosePathHeading")}>
          <button
            type="button"
            className="start-path-card start-path-card--interactive"
            role="radio"
            aria-checked="false"
            onClick={chooseInteractive}
          >
            <span className="start-path-card__icon" aria-hidden="true">
              <i className="fas fa-th-large" />
            </span>
            <span className="start-path-card__body">
              <span className="start-path-card__title-row">
                <h3 className="start-path-card__title">{t("wizardChoosePathInteractiveTitle")}</h3>
                <span className="start-path-card__badge">{t("wizardChoosePathRecommended")}</span>
              </span>
              <span className="start-path-card__desc">{t("wizardChoosePathInteractiveDesc")}</span>
            </span>
          </button>

          <button
            type="button"
            className="start-path-card start-path-card--static"
            role="radio"
            aria-checked="false"
            onClick={chooseStatic}
          >
            <span className="start-path-card__icon" aria-hidden="true">
              <i className="fas fa-file-upload" />
            </span>
            <span className="start-path-card__body">
              <span className="start-path-card__title-row">
                <h3 className="start-path-card__title">{t("wizardChoosePathStaticTitle")}</h3>
              </span>
              <span className="start-path-card__desc">{t("wizardChoosePathStaticDesc")}</span>
            </span>
          </button>
        </div>
      </div>

      <div className="toolbar toolbar-bottom start-toolbar">
        <button className="btn btn-secondary sw-btn-prev me-1 start-btn-back" onClick={goPrev} type="button">
          ← {t("back")}
        </button>
        <div className="wizard-step-counter">{t("wizardStep2Choose")}</div>
        <div className="start-btn-next-placeholder" aria-hidden="true" />
      </div>
    </>
  );
};

export default Step2ChoosePath;
